// extracted by mini-css-extract-plugin
export default {"References":"references_References__L1YJw","Overlay":"references_Overlay__ObyzT"};